export default __webpack_public_path__ + "static/media/Post-RocketDAO-mini.d3d1648c.png";